<template>
    <th class="th-aips table-aips-header">
        <slot></slot>
    </th>
</template>

<script setup>
const props = defineProps({
    columnName: {
        type: String,
        default: '',
    }
})
</script>

<script>
export default {
    name: 'ThAips'
};
</script>

<style lang="scss">
.th-aips {
    &:hover {
        background: none !important;
        cursor: auto !important;
    }
}
</style>
